import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IConfigurationStaffCategoryListResponseData } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import {
  setBomSetupList,
  setCityList,
  setClinicListTable,
  setEquipmentList,
  setServiceList,
  setStaffCategoryList,
} from "@/app_redux/reducers/slices/auth/configuration_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type ConfigurationModuleSearchModuleIdType = "city" | "clinic" | "equipment" | "service" | "staff_category" | "bom";
export const useConfigurationModuleSearchAPI = (moduleId: ConfigurationModuleSearchModuleIdType) => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (query: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .get(`${CONFIGURATION_APIS?.SEARCH_MODULE_API?.baseURL}`, {
            params: {
              page: moduleId,
              search_keyword: query,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<{ status: boolean; message: string; data: any }>) => {
            if (res.data.status === true) {
              if (moduleId === "city") {
                dispatch(
                  setCityList({
                    data: res.data.data,
                  }),
                );
              }
              if (moduleId === "clinic") {
                dispatch(
                  setClinicListTable({
                    data: res.data.data,
                  }),
                );
              }
              if (moduleId === "equipment") {
                dispatch(
                  setEquipmentList({
                    data: res.data.data,
                  }),
                );
              }

              if (moduleId === "staff_category") {
                dispatch(
                  setStaffCategoryList({
                    data: res.data.data as IConfigurationStaffCategoryListResponseData[],
                  }),
                );
              }
              if (moduleId === "service") {
                dispatch(
                  setServiceList({
                    data: res.data.data,
                  }),
                );
              }
              if (moduleId === "bom") {
                dispatch(
                  setBomSetupList({
                    data: res.data.data,
                  }),
                );
              }
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while searching");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return execute;
};
